(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["video"] && !Shopify.designMode) return;
  try {
    (() => {
    /* Load the lightbox embed only while it is open. */
    const setEmbedState = (root, open) => {
      root.querySelectorAll('iframe[data-src]').forEach((frame) => {
        frame.src = open ? frame.dataset.src : 'about:blank';
      });
    };

    document.addEventListener(
      'click',
      (event) => {
        const trigger = event.target.closest?.('.video-lightbox__trigger');
        if (trigger) setEmbedState(trigger.closest('.video-lightbox'), true);
      },
      true
    );

    document.addEventListener(
      'close',
      (event) => {
        if (event.target.matches?.('.video-lightbox__dialog')) setEmbedState(event.target, false);
      },
      true
    );
  })();
  } catch(e) { console.error(e); }
})();

})();
